















































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import LayoutNav from '../../layouts/layout-nav.vue';
import { Image, Tab, Tabs, Dialog, Checkbox } from 'vant';
import DfMarkdownReader from '../../components/DfMarkdownReader.vue';
import SpecialCompetition from '../../components/special/special-competition.vue';
import SpecialInstruction from '../../components/special/special-instruction.vue';
import SpecialStatistics from '../../components/special/special-statistics.vue';
import GoTop from '../../components/common/go-top.vue';

@Component({
    components: {
        [Image.name]: Image,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        LayoutNav,
        [Dialog.Component.name]: Dialog.Component,
        DfMarkdownReader,
        [Checkbox.name]: Checkbox,
        SpecialCompetition,
        SpecialInstruction,
        SpecialStatistics,
        GoTop,
    },
})
export default class Special extends Vue {
    public id = this.$route.params.id;
    public preview = this.$route.query.preview;
    // public showSubmits = false;
    public contest = {
        relatedSpecials: [],
        special: { content: '', linkUrl: '' },
    };

    public groupNames: any[] = [];
    public competitionList: any[] = [];
    public totals: any[] = [];

    public customContentTab: any[] = [];

    public canShare = false; // 是否当前专题后台配置有活动

    get pageTitle() {
        return this.contest.special ? (this.contest.special as any).title : '';
    }

    get showSubmits(){
        // 某些专题下既有算法赛，又不希望展示提交数，则将专题route添加到下方 blackList 中
        const blackList = ['galaxycup2022']
        let rst = false
        blackList.forEach(item => {
            if(this.$route.fullPath.search(item) > -1) rst = true
        })
        return rst
    }

    get getBannerUrl() {
        const bannerUrl = (this.contest.special as any).bannerUrl;
        const bannerUrlWap = (this.contest.special as any).bannerUrlWap;
        return bannerUrlWap || bannerUrl; // 应该展示移动端url，但是避免运营同学漏配了
    }

    get isGZS(){
        return this.id === 'fairylake2024'
    }
    get isSXH(){
        return this.id === 'fairylake2025'
    }
    get isZQB(){
        return this.id === 'ZQB'
    }

    // @Getter('userInfo') user!: any;

    async mounted() {
        this.fetchSpecials();
        this.queryShareInfo();
        console.log(this.id);
    
        await this.fetchCompetitions();
        const { utm_source, utm_medium, utm_campaign, utm_content, utm_term } = this.$route.query;
        const ids: any = [];
        for (const competition of this.competitionList) {
            ids.push(competition.id);
        }
        // 埋点
        this.$axios('competition_visited', {
            ids,
            url: window.location.href,
            refer_url: document.referrer,
            page_type: 0,
            browser_type: 1,
            utm_source,
            utm_medium,
            utm_campaign,
            utm_content,
            utm_term,
        });
    }

    async fetchSpecials() {
        const result = await this.$axios('sepcialGetRaceSpecials', { preview: this.preview }, `/${this.id}`);
        const { relatedSpecials = [], special = {} } = result.data.data;
        this.contest.relatedSpecials = relatedSpecials;
        this.contest.special = special;
        document.title = special.title;

        // 下面是自定义的tab内容
        let arr: any = []
        if(this.contest.special && (this.contest.special as any).content1Desc){
            console.log(888);
            arr.push({
                title: (this.contest.special as any).navigations.find((item: any) => item.name === 'content-1')['title'],
                markdownContent: (this.contest.special as any).content1Desc
            })
        }
        console.log(arr)
        if(this.contest.special && (this.contest.special as any).content2Desc){
            arr.push({
                title: (this.contest.special as any).navigations.find((item: any) => item.name === 'content-2')['title'],
                markdownContent: (this.contest.special as any).content2Desc
            })
        }
        if(this.contest.special && (this.contest.special as any).content3Desc){
            arr.push({
                title: (this.contest.special as any).navigations.find((item: any) => item.name === 'content-3')['title'],
                markdownContent: (this.contest.special as any).content3Desc
            })
        }
        if(this.contest.special && (this.contest.special as any).content4Desc){
            arr.push({
                title: (this.contest.special as any).navigations.find((item: any) => item.name === 'content-4')['title'],
                markdownContent: (this.contest.special as any).content4Desc
            })
        }
        if(this.contest.special && (this.contest.special as any).content5Desc){
            arr.push({
                title: (this.contest.special as any).navigations.find((item: any) => item.name === 'content-5')['title'],
                markdownContent: (this.contest.special as any).content5Desc
            })
        }
        this.customContentTab = arr
    }

    async fetchCompetitions() {
        const result = await this.$axios('sepcialGetRaceSpecials', {}, `/${this.id}/competitions`);
        const competitionList = result.data.data;
        // competitionList.forEach(cmpt => {
        //     if (cmpt.typeLabel.indexOf('算法') > -1) this.showSubmits = true;
        // });

        const groupSet = new Set();
        let totals = [
            {
                icon: '',
                title: '总参赛人数',
                label: 'special.total_players',
                count: 0,
            },
            {
                icon: '',
                title: '总参赛队伍数',
                label: 'special.total_teams',
                count: 0,
            },
            {
                icon: '',
                title: '总作品提交数',
                label: 'special.total_submissions',
                count: 0,
            },
        ];
        competitionList.map(x => {
            totals[0].count += x.addition.totalSignupUsers;
            totals[1].count += x.addition.totalTeams;
            totals[2].count += x.addition.totalSubmits;
            groupSet.add(x.groupName);
        });
        this.groupNames = Array(...groupSet);
        this.competitionList = competitionList;
        this.totals = totals;
    }

    async queryShareInfo() {
        try {
            const result = await this.$axios('contestActivityQuery', { id: this.id });
            const actitity = result['data']['data'][0];
            if (actitity) {
                const { deleted_at, is_open } = actitity;
                if (!deleted_at && is_open) {
                    this.canShare = true;
                } else {
                    this.canShare = false;
                }
            } else {
                this.canShare = false;
            }
        } catch (e) {
            this.canShare = false;
        }
    }

    handleBack2Home() {
        location.href = this.contest.special.linkUrl || '/';
    }

    get markdownArray() {
        if (!(this.contest.special as any).content) {
            return {
                first: [],
                second: [],
            };
        }
        const reg = /## [^#\n]*\n*/g;
        const contentStr = (this.contest.special as any).content;
        const titleArrayInit = contentStr.match(reg) || [];
        const titleArray: string[] = [];
        titleArrayInit.forEach(item => {
            const reg = new RegExp(`#${item}`);
            if (!reg.test(contentStr)) {
                titleArray.push(item); // 避免 "## 大赛奖励\n\n#### 选手奖项这种情况"
            }
        });

        const contentArray: string[] = [];
        let contentStrLast = contentStr;
        titleArray.forEach(item => {
            const contentList = contentStrLast.split(item);
            contentArray.push(contentList[0]);
            contentStrLast = contentList[1];
        });
        contentArray.push(contentStrLast);
        contentStrLast = '';

        const list: any[] = [];
        let item = { title: '', markdownContent: '' };
        for (let index = 0; index < titleArray.length || index < contentArray.length; index++) {
            if (index < contentArray.length) {
                item.markdownContent = contentArray[index];
                if (item.title || item.markdownContent) {
                    list.push(item);
                }
                item = { title: '', markdownContent: '' };
            }
            if (index < titleArray.length) {
                item.title = titleArray[index];
            }
        }

        const index = list.findIndex(item => {
            return /大赛介绍/.test(item.title);
        });
        let first: any[] = [];
        if (index > -1) {
            first = list.splice(index, 1);
        }
        return {
            first,
            second: list,
        };
    }

    // 页面滚动滚动到顶部
    public onClickJoin() {
        (this.$refs['ref-competition'] as any).$el.scrollIntoView();
    }

    // 跳转活动页
    public onClickShare() {
        this.$router.push(`/activity/${this.id}`);
    }
}
